import { render, staticRenderFns } from "./eg_radio_input.vue?vue&type=template&id=6a22cad5&"
import script from "./eg_radio_input.vue?vue&type=script&lang=js&"
export * from "./eg_radio_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports